import { render, staticRenderFns } from "./products.vue?vue&type=template&id=80683368&class=app-bg-login&"
import script from "./products.vue?vue&type=script&lang=ts&"
export * from "./products.vue?vue&type=script&lang=ts&"
import style0 from "./products.vue?vue&type=style&index=0&id=80683368&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports